import { TooltipCircle } from "components/tooltipCircle";
import { ReactNode } from "react"

interface DescriptionItemProps {
  icon: any;
  iconFillColor?: string;
  label: string;
  content: ReactNode;
  additionalLabel?: ReactNode;
  contentSize?: "sm" | "md";
  hint?: string;
}

export const DescriptionItem = (props: DescriptionItemProps) => {
  const { contentSize = "sm" } = props;
  return (
    <div className="flex w-full px-4 py-6 sm:px-6">
      <div className="self-center shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-brand-secondary-400 mr-3">
        <props.icon 
          className={"size-4 text-brand-secondary-500"}
          {...(props.iconFillColor ? {fill: props.iconFillColor} : {})}
        />
      </div>
      <div className={`flex-1 sm:grid sm:grid-cols-5 sm:gap-4`}>
        <div className="flex flex-row flex-wrap items-center justify-start gap-x-4 gap-y-2">
          <div className="text-sm font-medium flex flex-wrap items-center gap-2">{props.label} {props.hint ? <TooltipCircle text={props.hint} /> : <></>} {props.additionalLabel}</div>
        </div>
        <div className={`self-center mt-2 ${contentSize}:mt-0 ${contentSize}:col-span-4`}>
          {props.content}
        </div>
      </div>
    </div>
  )
}